import { MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT } from '@ardoq/graph-labeling';
import type { ComponentGraphNode, LeafNodeLayout } from '@ardoq/graph';
import {
  MODERNIZED_BLOCK_DIAGRAM_LEAF_NODE_SHAPE_HEIGHT as SHAPE_HEIGHT,
  MODERNIZED_BLOCK_DIAGRAM_NODE_HEIGHT as NODE_HEIGHT,
  MODERNIZED_BLOCK_DIAGRAM_LEAF_NODE_PADDING as PADDING,
  MODERNIZED_BLOCK_DIAGRAM_CONDITIONAL_FORMATTING_INSET as CONDITIONAL_FORMATTING_INSET,
  MODERNIZED_BLOCK_DIAGRAM_CONDITIONAL_FORMATTING_STROKE_WIDTH as CONDITIONAL_FORMATTING_STROKE_WIDTH,
} from 'yfilesExtensions/styles/modernized/consts';
import { otherLabelsHeight } from '../leafNodeLabel/otherLabelsHeight';
import { wrapLeafNodeLabel } from './wrapLeafNodeLabel';

/**
 * Minimum bottom margin needed to keep content clear of the CF stroke inner
 * edge (inset + half stroke width). Applied unconditionally so node height is
 * stable regardless of whether CF is currently active.
 */
const BOTTOM_PADDING =
  PADDING +
  CONDITIONAL_FORMATTING_INSET +
  CONDITIONAL_FORMATTING_STROKE_WIDTH / 2;

const layoutLeafNode = (graphNode: ComponentGraphNode): LeafNodeLayout => {
  const itemLabels = graphNode.getItemLabels();
  if (!itemLabels) {
    return {
      wrappedMainLabel: [],
      shapeY: NODE_HEIGHT / 2 - SHAPE_HEIGHT,
      nodeHeight: NODE_HEIGHT,
    };
  }
  const { mainLabel } = itemLabels;
  const wrappedMainLabel = mainLabel ? wrapLeafNodeLabel(mainLabel) : [];
  const mainLabelHeight = wrappedMainLabel.length * LINE_HEIGHT;
  const additionalHeight = otherLabelsHeight(graphNode);
  const contentHeight =
    SHAPE_HEIGHT +
    (mainLabelHeight ? PADDING + mainLabelHeight : 0) +
    (additionalHeight ? PADDING + additionalHeight : 0);
  const nodeHeight = Math.max(
    NODE_HEIGHT,
    contentHeight + PADDING + BOTTOM_PADDING
  );
  // When content fits within NODE_HEIGHT, center it vertically.
  // When content overflows (nodeHeight > NODE_HEIGHT), top-align with PADDING
  // so the bottom gap equals BOTTOM_PADDING and content stays clear of the CF stroke.
  const shapeY =
    nodeHeight > NODE_HEIGHT ? PADDING : nodeHeight / 2 - contentHeight / 2;
  return {
    wrappedMainLabel,
    shapeY,
    nodeHeight,
  };
};
export { layoutLeafNode };
